"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const menuTheme = (0, _sdsThemeInternal.themed)({
  borderRadius: {
    "lodestar-light": _designTokens.border.radius10,
    "ursa-light": _designTokens.border.radius30
  },
  fontSize: {
    "lodestar-light": "inherit",
    "ursa-light": "14px"
  },
  optionHeight: {
    // Ursa uses 38px for both normal and compact menu items.
    normal: {
      "lodestar-light": 40,
      "ursa-light": 38
    },
    compact: {
      "lodestar-light": 32,
      "ursa-light": 38
    },
    dense: {
      "lodestar-light": 32,
      "ursa-light": 32
    }
  },
  separatorHeight: {
    "lodestar-light": 24,
    "ursa-light": 24
  },
  fontColor: {
    rest: {
      "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--default"),
      "ursa-light": (0, _designTokensReact.color)("color--text--neutral--default")
    },
    focus: (0, _designTokensReact.color)("color--text--neutral--strong"),
    hover: (0, _designTokensReact.color)("color--text--neutral--strong"),
    disabled: (0, _designTokensReact.color)("color--text--neutral--weaker")
  },
  boxShadow: (0, _designTokensReact.color)("elevation--default"),
  backgroundColor: {
    focus: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--weak"),
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weaker")
    },
    pressed: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--weak"),
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--default")
    },
    hover: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--weak"),
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weakest")
    },
    rest: (0, _designTokensReact.color)("color--background--surfaces--work")
  },
  hasContentLeftPadding: {
    "lodestar-light": "28px",
    "ursa-light": "32px"
  },
  motion: {
    itemBackground: {
      "lodestar-light": "",
      "ursa-light": `background-color ${_designTokens.motion.animation.default}`
    },
    animation: {
      "lodestar-light": "",
      "ursa-light": _designTokens.motion.animation.default
    }
  }
});
exports.menuTheme = menuTheme;
//# sourceMappingURL=menuTheme.js.map